import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type SectionContactDetailsStore } from 'pages/conversations/pages/search/pages/profile/ui/SectionContactDetails'

export const SectionContactDetailsContext = createContext<SectionContactDetailsStore | null>(null)

export const useSectionContactDetailsContext = () => {
  const context = useContext(SectionContactDetailsContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with SectionContactDetailsContext'
    )

  return context
}

type IProviderSectionContactDetailsProps = {
  value: SectionContactDetailsStore
  children: ReactNode
}

export const ProviderSectionContactDetails: FC<IProviderSectionContactDetailsProps> = ({
  value,
  children,
}) => {
  return (
    <SectionContactDetailsContext.Provider value={value}>
      {children}
    </SectionContactDetailsContext.Provider>
  )
}
